// extracted by mini-css-extract-plugin
export var divider = "_w1-0";